import React, { Component } from 'react';
import { Grid, Button, Input, Segment } from 'semantic-ui-react';
import EmailInput from './EmailInput';
import ClaimSummary from './ClaimSummary';
import { withApollo, compose, graphql } from 'react-apollo';
import { CurrentClaim } from '../queries/CurrentClaim'
import { Link } from 'react-router-dom';
import Content from './Content'
import PathView from './PathView'
import AttachmentsList from './AttachmentsList';
import mapCPTs from '../utils/mapCPTs'
import DocumentTitle from './DocumentTitle'
import { CreateOutgoingEmailMessage } from '../mutations/CreateOutgoingEmailMessage';
import * as messageActions from '../actions/message-actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class Contact extends Component {
  state = { subject: 'Claim contact', emailBody: '', selectedAttachments: [] }

  handleEmailBodyChange(e) {
    this.setState({
      emailBody: e.target.value
    })
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleAttachmentsSelectionChange = ( attachment ) => {
    let joined, attachmentIndex;
    if ( this.state.selectedAttachments.includes(attachment) ){
      joined = this.state.selectedAttachments;
      attachmentIndex = joined.indexOf(attachment);
      joined.splice(attachmentIndex,1);
    } else {
      joined = this.state.selectedAttachments.concat(attachment);
    }
    this.setState({
      selectedAttachments: joined
    });
  }

  handleEmailSent = () => {
    this.props.actions.showMessage({
        header: 'Success',
        text: 'The email has been successfully sent!',
        props: {success: true},
        duration: 2000
      });
    this.props.history.goBack()
  }

  handleMessageSend(recipient, sender, senderType) {
    const {subject, emailBody} = this.state
      this.setState({loading: true})
      return (
        this.props.CreateOutgoingEmailMessage({
          variables: {
            input: {
              emailMessage: {
                from: sender,
                claimId: this.props.match.params.id,
                to: recipient,
                subject: subject,
                content: emailBody,
                senderType: senderType,
                triggeringType: 'manual',
                documentIds : this.state.selectedAttachments.map( id => { return Number(id)})
              }
            }
          }
        }).then(() => {
          this.setState({loading: false})
          this.handleEmailSent()
        }).catch((error) => {
          console.error(error)
          this.setState({loading: false})
        })
      )
  }
  render = () => {
    const {CurrentClaim, location, history} = this.props
    const claim = CurrentClaim.claim || {}
    const passengerTicket = claim.passengerTicket || {}
    const { documents } = mapCPTs(claim)
    let recipient, sender, senderType

    if (history.location.pathname.includes("airline")) {
      sender = "airlines@airrefund.com"
      recipient = claim.airlineCustomerServiceEmail;
      senderType = 'airline'
    } else {
      sender = "myclaim@airrefund.com"
      recipient = (location.state && location.state.passengerEmail) ||
        passengerTicket.passengerEmail;
        senderType = 'pax'
    }

    return (
      <Content fullWidth>
        <DocumentTitle title={`Claim ${this.props.match.params.id}`} />
        <PathView paths={[
          { name: 'Claims', path: '/claims' },
          { name: this.props.match.params.id, path: `/claim/${this.props.match.params.id}` },
          { name: 'Contact' }
        ]} />
        <Segment loading={this.props.CurrentClaim.loading || this.state.loading} >
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <ClaimSummary {...this.props} claim={claim} />
              </Grid.Column>
              <Grid.Column width={9}>
                <EmailInput
                  senderEmail={sender}
                  recipientIconName="user"
                  body={this.state.emailBody}
                  recipient={recipient}
                  subject={<Input name='subject' fluid value={this.state.subject} onChange={this.handleChange} />}
                  recipientEditable={false}
                  selectedTemplate='Custom Notice'
                  onChange={this.handleEmailBodyChange.bind(this)}
                />
                <AttachmentsList
                  attachments={documents}
                  selectedAttachments={this.state.selectedAttachments}
                  handleAttachmentsSelectionChange={this.handleAttachmentsSelectionChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button floated="right" primary onClick={this.handleMessageSend.bind(this, recipient, sender, senderType)}
                  disabled={ !( recipient && this.state.subject && this.state.emailBody !== '') }
                >Send</Button>
                <Button as={Link} to={`/claim/${this.props.match.params.id}`} floated="right">Back</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Content>
    )
  }
}

const ContactWithData = compose(
  withApollo,
  graphql(CurrentClaim, {
    name: 'CurrentClaim',
    options: (props) => {
      return {
        variables: {
          id: props.match.params.id
        }
      }
    }
  }),
  graphql(CreateOutgoingEmailMessage, {name: 'CreateOutgoingEmailMessage'})
)(Contact)


export default connect(null, dispatch => ({
  actions: bindActionCreators(messageActions, dispatch)
}))(ContactWithData);



// WEBPACK FOOTER //
// ./src/component/Contact.js